import React, { useEffect, useState } from "react";
import { useLocation, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from "lodash";

import * as loaderAction from "redux/loader/action";
import { withSocket } from "socket/context";
import StartFreeTrial from "./components/StartFreeTrial";

const TrialLoginForm = (props) => {
  const socket_connected = _.get(props, "socketReducer.socketConnection");
  const current_user = _.get(props, "gameReducer.currentUser");
  const [disablePhoneNum, setDisablePhoneNum] = useState(true);
  const search = useLocation().search;

  useEffect(() => {
    const showPhoneNumber = new URLSearchParams(search).get("path");

    if (showPhoneNumber == "a") {
      setDisablePhoneNum(false);
    }
  }, [current_user?.team?.id, search]);

  useEffect(() => {
    if (socket_connected) {
      props.setIsLoading(false);
    } else {
      props.setIsLoading(true);
    }
  }, [socket_connected]);

  return (
    <StartFreeTrial history={props.history} disablePhoneNum={disablePhoneNum} />
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  socketReducer: state.socketReducer
});

const mapDispatchToProps = (dispatch) => ({
  setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
});

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(TrialLoginForm);
